import { render, staticRenderFns } from "./CmgSustainabilityStatsPage.vue?vue&type=template&id=1e178df6&scoped=true&lang=pug"
import script from "./cmg-sustainability-stats-page.ts?vue&type=script&lang=ts&external"
export * from "./cmg-sustainability-stats-page.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgSustainabilityStatsPage.vue?vue&type=style&index=0&id=1e178df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e178df6",
  null
  
)

export default component.exports